import { View } from '../../compiler'
import { colors, typoStyles } from '../../constants'
import { getColors, getIconOverallReview } from '../../utils/matching-profile'
import MarkdownText from '../MarkdownText'

const OurReview = ({ title, description, score, score_key }) => {
  const { dark, medium, light } = getColors({ score, score_key })
  const Icon = getIconOverallReview({ score, score_key })

  return (
    <View
      style={{
        backgroundColor: colors.lightPaleGrey,
        borderWidth: 1,
        borderColor: colors.lightGrey,
        borderRadius: 8
      }}
    >
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          paddingHorizontal: 24,
          paddingTop: 16,
          paddingBottom: 16 - 4, // minus border
          borderBottomWidth: 4,
          borderColor: medium
        }}
      >
        <View
          style={{
            width: 40,
            height: 40,
            borderRadius: 6,
            backgroundColor: light
          }}
          className='flex items-center justify-center'
        >
          <Icon style={{ width: 20, height: 20, color: dark }} />
        </View>
        <MarkdownText style={[typoStyles.H4Black, { marginLeft: 24 }]}>
          {title}
        </MarkdownText>
      </View>
      <View style={{ padding: 24 }}>
        <MarkdownText style={typoStyles.T1Black}>{description}</MarkdownText>
      </View>
    </View>
  )
}

export default OurReview
